export const TERMINAL_SCAN_SUBJECT_TYPE = 'terminals.scan';
export const TERMINAL_SCANS_REVIEW_PERMISSION = 'terminals:scans:review';

export type TerminalScanReceiptKind = 'online' | 'batch';

export type TerminalScanReviewItem = {
  subjectType: typeof TERMINAL_SCAN_SUBJECT_TYPE;
  eventId: string;
  personId: string;
  firstName: string;
  lastName: string;
  eventAt: string;
  terminalId: string;
  terminalLogicalId: string;
  terminalName: string;
  reason: string;
  receiptKind: TerminalScanReceiptKind;
};
